// Common disposable email domains to block on registration
// This is a minimal list; consider using an npm package for a more comprehensive list
const DISPOSABLE_DOMAINS = new Set([
  'mailinator.com',
  'guerrillamail.com',
  'guerrillamail.de',
  'tempmail.com',
  'throwaway.email',
  'temp-mail.org',
  'fakeinbox.com',
  'sharklasers.com',
  'guerrillamailblock.com',
  'grr.la',
  'dispostable.com',
  'yopmail.com',
  'yopmail.fr',
  'trashmail.com',
  'trashmail.me',
  'mailnesia.com',
  'maildrop.cc',
  'discard.email',
  'getnada.com',
  'tempr.email',
  'binkmail.com',
  '10minutemail.com',
  'tempail.com'
])

export function isDisposableEmail(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase()
  return domain ? DISPOSABLE_DOMAINS.has(domain) : false
}
